// extracted by mini-css-extract-plugin
module.exports = {"resultList":"Daily_resultList__exHCQ"};